import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import {
  CardContent,
  Typography,
  IconButton,
  Box,
  Avatar,
  Button,
  Card,
  Dialog,
  Stack,
  TextField,
} from '@mui/material';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import RepeatIcon from '@mui/icons-material/Repeat';

import { useTheme } from '@emotion/react';
import {
  BookmarkAdd,
  CodeOutlined,
  Delete,
  DeleteForever,
  LinkOutlined,
  MoreVert,
  ShareOutlined,
  Visibility,
} from '@mui/icons-material';
import { Link, useParams } from 'react-router-dom';
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  RedditIcon,
  RedditShareButton,
  TelegramIcon,
  TelegramShareButton,
  TwitterIcon,
  TwitterShareButton,
} from 'react-share';
import { toast } from 'react-toastify';
import MarkdownPreview from '@uiw/react-markdown-preview';
import PublicProfilePage from '../publicProfilePage';
import { formatCount, formatSi } from '../../../utils';
import UserBadge from '../userBadge';
const FeedContentAdmin = ({
  data,
  setData,
  hoot,
  setFeedData,
  deleteHandler,
  updatePayload,
}) => {
  const { userInfo } = useSelector((state) => state.userInfo);
  const [showShareModal, setShowShareModal] = useState(false);
  const [username, setUsername] = useState(hoot?.authorUsername);
  const [email, setEmail] = useState(hoot?.authorEmail);

  const theme = useTheme();

  const handleLike = async (hootId) => {
    try {
      await axios.put('https://soapboxapi.megahoot.net/upload/increment-like', {
        hootId,
      });
      setFeedData((prevData) =>
        prevData.map((post) =>
          post.id === hoot.id ? { ...post, likes: post.likes + 1 } : post
        )
      );
    } catch (error) {
      console.error(error);
    }
  };

  const addToUpdateHandler = () => {
    try {
      updatePayload((prev = []) => {
        const exists = prev.find((p) => p.id === hoot?.id);
        if (exists) {
          return prev.map((p) =>
            p.id === hoot?.id ? { ...p, email: email, username: username } : p
          );
        }
        return [
          ...prev,
          { postId: hoot?.id, email: email, username: username },
        ];
      });

      toast.info('Post added to queue');
    } catch (error) {
      toast.error('Please try again');
    }
  };

  return (
    <>
      <Card
        elevation={50}
        sx={{
          borderRadius: 0,
          bgcolor: '#000',
          color: '#fff',
          border: '1px solid grey',
          borderLeft: 'none',
          width: '300px',
        }}
      >
        <CardContent
          sx={{
            bgcolor: '#000',
            position: 'relative',
            height: '100%',
          }}
        >
          <Box
            component="div"
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              gap: 1,
              color: '#fff',
            }}
          >
            <Link to={`/profile/${hoot.authorUsername}`}>
              <Avatar
                sx={{ height: '30px', width: '30px', border: '1px solid grey' }}
                src={`https://soapboxapi.megahoot.net/profile-pictures/${hoot.authorProfilePic}`}
              />
            </Link>
            <input
              style={{ width: '100%' }}
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </Box>
          <input
            style={{ width: '100%' }}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Button variant="contained" onClick={addToUpdateHandler}>
            Add to update
          </Button>
          {/* <MarkdownPreview
            source={hoot.caption}
            // style={
            //   fontFamilyStyle
            //     ? {
            //         all: 'unset',
            //         padding: 4,
            //         wordWrap: 'break-word',
            //         width: '100%',
            //         overflow: 'auto',
            //         color: fontFamilyStyle?.color,
            //         backgroundColor: fontFamilyStyle?.bgColor,
            //       }
            //     : {
            //         padding: 4,
            //         wordWrap: 'break-word',
            //         maxWidth: '100%',
            //         overflow: 'auto',
            //         maxHeight: '200px',
            //         backgroundColor: '#fff',
            //       }
            // }
            style={{
              padding: 4,
              wordWrap: 'break-word',
              maxWidth: '100%',
              overflow: 'auto',
              backgroundColor: '#fff',
            }}
          /> */}
        </CardContent>
      </Card>

      {/* <Dialog
        maxWidth="lg"
        open={showProfile}
        fullWidth={true}
        onClose={() => setShowProfile(false)}
      >
        <PublicProfilePage
          username={selectedProfile?.username}
          setMessages={setMessages}
          tabValue={tabValue}
          setTabValue={setTabValue}
        />
      </Dialog> */}
    </>
  );
};

export default FeedContentAdmin;
